export default "__VITE_ASSET__D9sCa8N5__"